// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const TypeReference = {
    container: (value) => {
        return {
            container: value,
            type: "container",
            _visit: function (visitor) {
                return FernIr.TypeReference._visit(this, visitor);
            },
        };
    },
    named: (value) => {
        return Object.assign(Object.assign({}, value), { type: "named", _visit: function (visitor) {
                return FernIr.TypeReference._visit(this, visitor);
            } });
    },
    primitive: (value) => {
        return {
            primitive: value,
            type: "primitive",
            _visit: function (visitor) {
                return FernIr.TypeReference._visit(this, visitor);
            },
        };
    },
    unknown: () => {
        return {
            type: "unknown",
            _visit: function (visitor) {
                return FernIr.TypeReference._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "container":
                return visitor.container(value.container);
            case "named":
                return visitor.named(value);
            case "primitive":
                return visitor.primitive(value.primitive);
            case "unknown":
                return visitor.unknown();
            default:
                return visitor._other(value);
        }
    },
};
